import scope from "./scope";

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (columnDef) => ({
  type: SET_DEFINITIONS,
  columnDef,
});


